import { useState } from "react";

import {
    obtenerAgendaPublica,
    obtenerAgendaPublicaPorId,
    obtenerAgendaAdmin,
    crearAgenda,
    actualizarAgenda,
    eliminarAgenda,
} from "../Services/AgendaService";


// =====================================================
// HOOK PÚBLICO
// =====================================================

export const useAgendaPublica = () => {

    const [agendas, setAgendas] =
        useState([]);

    const [loading, setLoading] =
        useState(false);

    const [error, setError] =
        useState(null);


    // =========================================
    // CARGAR AGENDA
    // =========================================

    const cargarAgendaPublica = async () => {

        try {

            setLoading(true);

            setError(null);

            const response =
                await obtenerAgendaPublica();

            const data =
                response.data.agenda;

            setAgendas(
                Array.isArray(data)
                    ? data
                    : []
            );

            return response;

        } catch (error) {

            console.error(
                "Error al obtener agenda pública:",
                error
            );

            setError(error);

            throw error;

        } finally {

            setLoading(false);

        }

    };


    // =========================================
    // OBTENER UNA ACTIVIDAD
    // =========================================

    const obtenerActividad = async (id) => {

        try {

            setLoading(true);

            setError(null);

            const response =
                await obtenerAgendaPublicaPorId(id);

            return response;

        } catch (error) {

            console.error(
                "Error al obtener actividad:",
                error
            );

            setError(error);

            throw error;

        } finally {

            setLoading(false);

        }

    };


    return {

        agendas,

        loading,

        error,

        cargarAgendaPublica,

        obtenerActividad,

    };

};


// =====================================================
// HOOK ADMINISTRADOR
// =====================================================

export const useAgendaAdmin = () => {

    const [agendas, setAgendas] =
        useState([]);

    const [loading, setLoading] =
        useState(false);

    const [error, setError] =
        useState(null);


    // =========================================
    // CARGAR
    // =========================================

    const cargarAgendaAdmin = async () => {

        try {

            setLoading(true);

            setError(null);

            const response =
                await obtenerAgendaAdmin();

            const data =
                response.data.agenda;

            setAgendas(
                Array.isArray(data)
                    ? data
                    : []
            );

            return response;

        } catch (error) {

            console.error(
                "Error al obtener agenda administrativa:",
                error
            );

            setError(error);

            throw error;

        } finally {

            setLoading(false);

        }

    };


    // =========================================
    // CREAR
    // =========================================

    const guardarAgenda = async (data) => {

        try {

            setLoading(true);

            setError(null);

            const response =
                await crearAgenda(data);

            await cargarAgendaAdmin();

            return response;

        } catch (error) {

            console.error(
                "Error al crear agenda:",
                error
            );

            setError(error);

            throw error;

        } finally {

            setLoading(false);

        }

    };


    // =========================================
    // ACTUALIZAR
    // =========================================

    const editarAgenda = async (
        id,
        data
    ) => {

        try {

            setLoading(true);

            setError(null);

            const response =
                await actualizarAgenda(
                    id,
                    data
                );

            await cargarAgendaAdmin();

            return response;

        } catch (error) {

            console.error(
                "Error al actualizar agenda:",
                error
            );

            setError(error);

            throw error;

        } finally {

            setLoading(false);

        }

    };


    // =========================================
    // ELIMINAR
    // =========================================

    const borrarAgenda = async (id) => {

        try {

            setLoading(true);

            setError(null);

            const response =
                await eliminarAgenda(id);

            setAgendas(
                (prev) =>
                    prev.filter(
                        (item) =>
                            item.id !== id
                    )
            );

            return response;

        } catch (error) {

            console.error(
                "Error al eliminar agenda:",
                error
            );

            setError(error);

            throw error;

        } finally {

            setLoading(false);

        }

    };


    return {

        agendas,

        loading,

        error,

        cargarAgendaAdmin,

        guardarAgenda,

        editarAgenda,

        borrarAgenda,

    };

};